import { FilterTypes } from "../../../../types";
import { DateTime } from "luxon";
const INVENTORY_MODEL = {
    frequency: "delivery_billable_base.frequency",
    impressions: "delivery_billable_base.delivered_impressions",
    vcr: "delivery_explore.vcr",
    reach: "delivery_billable_base.reach",
    publisherId: "delivery_billable_base.pub__id",
    publisherName: "meta_publisher.name",
    productType: "delivery_billable_base.media_subtype",
    channel: "delivery_billable_base.channel",
    bundle: "delivery_billable_base.bundle",
    clicks: "delivery_billable_base.events_click_count"
};
const FILTERS_TO_LOOKER_FILTERS = {
    dates: "delivery_explore.flt_analysis_interval", // Already handled above
    publisherId: "delivery_billable_base.pub__id",
    channel: "delivery_billable_base.channel",
    bundle: "delivery_billable_base.bundle",
    campaignId: "delivery_meta_inst.campaign__id",
    advertiserId: "delivery_meta_inst.advertiser__id",
    productType: "delivery_billable_base.product_type"
};
export const lookerInventoryModelFieldsToQueryDimensions = (fields) => fields.map((field) => INVENTORY_MODEL[field]);
export const lookerInventoryQueryDimensionsToModel = (fields, queryFields) => {
    const model = {};
    fields.forEach((field) => {
        const queryFieldName = INVENTORY_MODEL[field];
        const queryField = queryFields[queryFieldName];
        if (queryField) {
            model[field] = queryField;
        }
    });
    return model;
};
/**
 * Helper function to get an array filter value if it exists
 * @param filters The filter array to search in
 * @param fieldName The field name to look for
 * @returns The joined filter value string or undefined if not found/valid
 */
const getArrayFilterValue = (filters, fieldName) => {
    const filter = filters.find((f) => f.field === fieldName);
    if (filter && Array.isArray(filter.value) && filter.value.length > 0) {
        return filter.value.join(",");
    }
    return undefined;
};
export const modelFiltersToQueryFilters = (filters) => {
    if (!filters?.where?.length) {
        throw new Error("Filters are required");
    }
    const dateFilter = filters.where.find((filter) => filter.field === "dates");
    if (!dateFilter) {
        throw new Error("Date range filter is required");
    }
    const queryFilters = {
        "delivery_explore.flt_analysis_interval": parseDateFilter(dateFilter)
    };
    if (filters.where.length === 1) {
        // If only the date filter is present, return early
        return queryFilters;
    }
    // Process all filter fields (except dates which is already handled)
    Object.entries(FILTERS_TO_LOOKER_FILTERS).forEach(([modelField, queryField]) => {
        if (modelField !== "dates") {
            const filterValue = getArrayFilterValue(filters.where || [], modelField);
            if (filterValue) {
                queryFilters[queryField] = filterValue;
            }
        }
    });
    return queryFilters;
};
export const parseDateFilter = (filter) => {
    let queryFilter = "";
    switch (filter.type) {
        case FilterTypes.BETWEEN: {
            if (!Array.isArray(filter.value)) {
                throw new Error(`Filter ${filter.field} must be an array of dates when filtering for a date range`);
            }
            const [startDate, endDate] = filter.value;
            if (!(startDate instanceof Date) || !(endDate instanceof Date)) {
                throw new Error(`Filter ${filter.field} must contain two dates when filtering for a date range`);
            }
            const formattedStartDate = DateTime.fromJSDate(startDate).toFormat("yyyy/MM/dd");
            // We add one day to the end date because Looker uses the end date as an exclusive filter, they show a message
            // in the UI that says "until (before)" which means that the end date is not included in the filter
            const formattedEndDate = DateTime.fromJSDate(endDate).plus({ day: 1 }).toFormat("yyyy/MM/dd");
            queryFilter = `${formattedStartDate} to ${formattedEndDate}`;
            break;
        }
    }
    return queryFilter;
};
//# sourceMappingURL=index.js.map